<template>
  <div class="container">
    <div>
      <img class="header" :src="require('@/assets/img/head.jpg')" />
      <div class="form">
        <div class="form-content">
          <!-- <div class="form-top">
          <div class="title">中山疫情实时情况</div>
          <van-divider class="divider" />
          <div class="positive-container">
            <div class="positive-left">
              <div class="positive-text">阳性个案人数</div>
              <div class="positive-num">{{ positiveNum }}</div>
              <div class="positive-text">人</div>
            </div>
            <div class="positive-right">
              <div class="positive-text">{{ expire }}</div>
            </div>
          </div>
        </div> -->
          <van-grid :border="false" :column-num="4">
            <van-grid-item class="grid-item" v-for="item in epidemicData" :key="item">
              
              <div
                class="wx-item"
                v-if="item.title == '疫苗接种点' && userAgentFlag == 'wechat' && isMobile"
              >
                <wx-open-launch-weapp
                  id="launch-btn-3"
                  username="gh_76d39991d53c"
                  path="pages/vaccinePlaceList/vaccinePlaceList.html"
                  style="width: 100%"
                  @launch="handleLaunch"
                  @error="handleError"
                >
                  <div v-is="'script'" type="text/wxtag-template">
                    <button style="border-width: 0; width: 100%; background: white" class="btn">
                      <img
                        style="width: 60vw; height: 60vw"
                        src="https://zsrbactivity.zsnews.cn/assets/img/7.png"
                      />
                    </button>
                  </div>
                </wx-open-launch-weapp>
                <wx-open-launch-weapp
                  id="launch-btn-4"
                  username="gh_76d39991d53c"
                  path="pages/vaccinePlaceList/vaccinePlaceList.html"
                  style="width: 100%"
                  @launch="handleLaunch"
                  @error="handleError"
                >
                  <div v-is="'script'" type="text/wxtag-template">
                    <button
                      style="
                        background: white;
                        border-width: 0;
                        font-size: 13.7vw;
                        color: #444;
                        font-weight: 400;
                        text-align: center;
                        width: 100%;
                      "
                      class="btn"
                    >
                      <span>{{ item.title }}</span>
                    </button>
                  </div>
                </wx-open-launch-weapp>
              </div>
              <div
                class="wx-item"
                v-else-if="item.title == '核酸检测点' && userAgentFlag == 'wechat' && isMobile"
              >
                <wx-open-launch-weapp
                  id="launch-btn-1"
                  username="gh_76d39991d53c"
                  path="pages/nucleinPlaceList/nucleinPlaceList.html"
                  style="width: 100%"
                  @launch="handleLaunch"
                  @error="handleError"
                >
                  <div v-is="'script'" type="text/wxtag-template">
                    <button style="border-width: 0; width: 100%; background: white" class="btn">
                      <img
                        style="width: 60vw; height: 60vw"
                        src="https://zsrbactivity.zsnews.cn/assets/img/1.png"
                      />
                    </button>
                  </div>
                </wx-open-launch-weapp>
                <wx-open-launch-weapp
                  id="launch-btn-2"
                  username="gh_76d39991d53c"
                  path="pages/nucleinPlaceList/nucleinPlaceList.html"
                  style="width: 100%"
                  @launch="handleLaunch"
                  @error="handleError"
                >
                  <div v-is="'script'" type="text/wxtag-template">
                    <button
                      style="
                        background: white;
                        border-width: 0;
                        font-size: 13.7vw;
                        color: #444;
                        font-weight: 400;
                        text-align: center;
                        width: 100%;
                      "
                      class="btn"
                    >
                      <span>{{ item.title }}</span>
                    </button>
                  </div>
                </wx-open-launch-weapp>
              </div>
              <div
                class="wx-item"
                v-else-if="item.title == '同乘查询' && userAgentFlag == 'wechat' && isMobile"
              >
                <wx-open-launch-weapp
                  id="launch-btn-5"
                  username="gh_0e163ff2ba74"
                  path="fangkongfuwu/pages/ConfirmedOrSuspectedCaseShareSelfCheck/fillInfo/fillInfo.html?eid=YQ_WJW_TXZXFW,GSS_YQ&source=yqResultPage"
                  style="width: 100%"
                  @launch="handleLaunch"
                  @error="handleError"
                >
                  <div v-is="'script'" type="text/wxtag-template">
                    <button style="border-width: 0; width: 100%; background: white" class="btn">
                      <img
                        style="width: 60vw; height: 60vw"
                        src="https://zsrbactivity.zsnews.cn/assets/img/19.png"
                      />
                    </button>
                  </div>
                </wx-open-launch-weapp>
                <wx-open-launch-weapp
                  id="launch-btn-6"
                  username="gh_0e163ff2ba74"
                  path="fangkongfuwu/pages/ConfirmedOrSuspectedCaseShareSelfCheck/fillInfo/fillInfo.html?eid=YQ_WJW_TXZXFW,GSS_YQ&source=yqResultPage"
                  style="width: 100%"
                  @launch="handleLaunch"
                  @error="handleError"
                >
                  <div v-is="'script'" type="text/wxtag-template">
                    <button
                      style="
                        background: white;
                        border-width: 0;
                        font-size: 13.7vw;
                        color: #444;
                        font-weight: 400;
                        text-align: center;
                        width: 100%;
                      "
                      class="btn"
                    >
                      <span>{{ item.title }}</span>
                    </button>
                  </div>
                </wx-open-launch-weapp>
              </div>
              <div
                class="wx-item"
                v-else-if="item.title == '风险地区' && userAgentFlag == 'wechat' && isMobile"
              >
                <wx-open-launch-weapp
                  id="launch-btn-7"
                  username="gh_dc5faf6be488"
                  path="publicService/pages/riskGrade/riskGrade.html?footer=本服务由国家卫生健康委提供&title=疫情风险等级查询&provider=本服务由国家卫生健康委提供"
                  style="width: 100%"
                  @launch="handleLaunch"
                  @error="handleError"
                >
                  <div v-is="'script'" type="text/wxtag-template">
                    <button style="border-width: 0; width: 100%; background: white" class="btn">
                      <img
                        style="width: 60vw; height: 60vw"
                        src="https://zsrbactivity.zsnews.cn/assets/img/5.png"
                      />
                    </button>
                  </div>
                </wx-open-launch-weapp>
                <wx-open-launch-weapp
                  id="launch-btn-8"
                  username="gh_dc5faf6be488"
                  path="publicService/pages/riskGrade/riskGrade.html?footer=本服务由国家卫生健康委提供&title=疫情风险等级查询&provider=本服务由国家卫生健康委提供"
                  style="width: 100%"
                  @launch="handleLaunch"
                  @error="handleError"
                >
                  <div v-is="'script'" type="text/wxtag-template">
                    <button
                      style="
                        background: white;
                        border-width: 0;
                        font-size: 13.7vw;
                        color: #444;
                        font-weight: 400;
                        text-align: center;
                        width: 100%;
                      "
                      class="btn"
                    >
                      <span>{{ item.title }}</span>
                    </button>
                  </div>
                </wx-open-launch-weapp>
              </div>
              <div v-else @click="jump(item.title, item.link)">
                <van-image class="form-image" :src="item.image" />
                <div class="form-text">{{ item.title }}</div>
              </div>
            </van-grid-item>
          </van-grid>
        </div>
      </div>
    </div>
    <div class="copyright">中山日报 中山+ 出品</div>
  </div>
</template>

<script>
import { Grid, GridItem, Image as VanImage, Divider, Toast } from "vant"
import { onMounted, computed } from "vue"
import { useStore } from "vuex"
import { wxshareInit } from "@/plugins/wechatSDK.js"
import "@/plugins/bridge.js"
// import { useRouter } from "vue-router"
export default {
  name: "Home",
  components: {
    [Toast.name]: Toast,
    [VanImage.name]: VanImage,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Divider.name]: Divider
  },
  setup() {
    const store = useStore()
    // const router = useRouter()

    const epidemicData = [
      // {
      //   image: require("../assets/img/13.png"),
      //   title: "疫情地图",
      //   link: "https://zsrbapp.zsnews.cn/mobile/rnaillness/index"
      // },
      // {
      //   image: require("../assets/img/3.png"),
      //   title: "病例轨迹",
      //   link: "https://zsrbactivity.zsnews.cn/vue/epidemic/#/cases"
      // },
      {
        image: require("../assets/img/6.png"),
        title: "本地动态 ",
        link: "https://zsrbapp.zsnews.cn/mobile/channel/#/?categoryId=114"
      },
      {
        image: require("../assets/img/1.png"),
        title: "核酸检测点",
        link: "https://zsrbapp.zsnews.cn/mobile/rnaillness/index2"
      },
      {
        image: require("../assets/img/17.png"),
        title: "疫情发布会",
        link: "http://wjj.zs.gov.cn/xxml/ztzj/xxgzbdfk/xwfbh/"
      },
      {
        image: require("../assets/img/4.png"),
        title: "应急求助",
        link: "https://zsrbactivity.zsnews.cn/vue/wish/#/"
      },
      {
        image: require("../assets/img/16.png"),
        title: "健康申报",
        // link: "https://zsrbapp.zsnews.cn/mobile/news/viewNews/590267"
        link: "http://fyfkxt.zszwfw.cn:8081/mobile/pages/rjry/guide?dateTime=1657432736000"
      },
      {
        image: require("../assets/img/14.png"),
        title: "防疫课堂",
        link: "https://zsrbapp.zsnews.cn/mobile/topic/view/589109"
      },
      {
        image: require("../assets/img/15.png"),
        title: "中山网课",
        link: "http://www.zsedu.cn/node/23715.jspx"
      },
      // {
      //   image: require("../assets/img/21.png"),
      //   title: "涉疫场所",
      //   link: "https://zsrbapp.zsnews.cn/mobile/rnaillness/index"
      // },
      {
        image: require("../assets/img/7.png"),
        title: "疫苗接种点",
        link: "https://zsrbapp.zsnews.cn/mobile/news/viewNews/589053"
      },
      // {
      //   image: require("../assets/img/2.png"),
      //   title: "核酸人流量",
      //   link: "https://gd.10086.cn/apph5/webapp/chart2.html "
      // },
      {
        image: require("../assets/img/8.png"),
        title: "疫情快报",
        link: "https://news.qq.com/zt2020/page/feiyan.htm#/"
      },
      {
        image: require("../assets/img/9.png"),
        title: "出行政策",
        link: " http://www.gov.cn/zhuanti/2021yqfkgdzc/index.htm#/"
      },
      {
        image: require("../assets/img/10.png"),
        title: "疫情辟谣",
        link: "https://vp.fact.qq.com/home"
      },
      {
        image: require("../assets/img/11.png"),
        title: "发热门诊",
        link: "https://feiyan.wecity.qq.com/wuhan/dist/index.html#/feiyanmap?cityCode=442000&cityName=%E4%B8%AD%E5%B1%B1&provinceName=%E5%B9%BF%E4%B8%9C&lat=0&lng=0&channel=&random=1647744202324&_scope=snsapi_base "
      },

      {
        image: require("../assets/img/5.png"),
        title: "风险地区",
        link: "https://2021quarantine.123jkb.cn/Pic/index.html"
      },
      {
        image: require("../assets/img/18.png"),
        title: "战疫海报",
        link: "https://zsrbactivity.zsnews.cn/vue/edipemicposter/#/"
      },
      {
        image: require("../assets/img/19.png"),
        title: "同乘查询",
        link: "fangkongfuwu/pages/ConfirmedOrSuspectedCaseShareSelfCheck/fillInfo/fillInfo.html?eid=YQ_WJW_TXZXFW,GSS_YQ&source=yqResultPage"
      },
      {
        image: require("../assets/img/20.png"),
        title: "医院挂号",
        link: "http://guahao.h13.cn/"
      }
    ]

    let userAgentFlag = ""
    let isMobile = false
    const userAgentString = navigator.userAgent.toLowerCase()
    console.log(userAgentString)

    if (userAgentString.indexOf("zsrbapp") >= 0) userAgentFlag = "zsrbapp"
    if (userAgentString.indexOf("micromessenger") >= 0) userAgentFlag = "wechat"

    if (userAgentString.indexOf("android") >= 0 || userAgentString.indexOf("iphone") >= 0) {
      isMobile = true
    }

    console.log(userAgentFlag)

    const jump = (title, url) => {
       if (title == "同乘查询") {
        if (userAgentFlag == "zsrbapp") {
          window.ZsrbApp.call("openWechatMini", {
            title: "同乘查询",
            img: "",
            desc: "",
            path: "fangkongfuwu/pages/ConfirmedOrSuspectedCaseShareSelfCheck/fillInfo/fillInfo.html?eid=YQ_WJW_TXZXFW,GSS_YQ&source=yqResultPage",
            originalId: "gh_0e163ff2ba74"
          })
        } else {
          Toast.fail("请用手机打开小程序")
        }
       }
       else if (title == "核酸检测点") {
        if (userAgentFlag == "zsrbapp") {
          window.ZsrbApp.call("openWechatMini", {
            title: "核酸检测点",
            img: "",
            desc: "",
            path: "pages/nucleinPlaceList/nucleinPlaceList.html",
            originalId: "gh_76d39991d53c"
          })
        } else {
          Toast.fail("请用手机打开小程序")
        }
      }
      else if (title == "风险地区") {
        if (userAgentFlag == "zsrbapp") {
          window.ZsrbApp.call("openWechatMini", {
            title: "风险地区",
            img: "",
            desc: "",
            path: "publicService/pages/riskGrade/riskGrade.html?footer=本服务由国家卫生健康委提供&title=疫情风险等级查询&provider=本服务由国家卫生健康委提供",
            originalId: "gh_dc5faf6be488"
          })
        } else {
          Toast.fail("请用手机打开小程序")
        }
      }
       else if (title == "疫苗接种点") {
        if (userAgentFlag == "zsrbapp") {
          window.ZsrbApp.call("openWechatMini", {
            title: "同乘查询",
            img: "",
            desc: "",
            path: "pages/vaccinePlaceList/vaccinePlaceList.html",
            originalId: "gh_76d39991d53c"
          })
        } else {
          Toast.fail("请用手机打开小程序")
        }
      } else {
        window.open(url, "_blank")
      }
    }

    const handleLaunch = (e) => {
      console.log(e)
    }

    const handleError = (e) => {
      console.log(e.detail)
    }

    onMounted(() => {
      store.dispatch("getPositive")
      const { aplus_queue } = window
      aplus_queue.push({
        action: "aplus.record",
        arguments: [
          "$$_exposure",
          "EXP",
          {
            page: "epidemic"
          }
        ]
      })
    })

    return {
      userAgentFlag,
      isMobile,
      handleLaunch,
      handleError,
      jump,
      epidemicData,
      positiveNum: computed(() => store.state.positiveNum),
      expire: computed(() => store.state.expire)
    }
  },
  created() {
    window.ZsrbApp.call("shareInfo", {
      title: "中山疫情防控服务平台",
      img: "https://zsrbactivity.zsnews.cn" + require("../assets/zsplus.png"),
      desc: "疫情防控一点通",
      url: "https://zsrbactivity.zsnews.cn/vue/epidemic/"
    })
    wxshareInit({
      title: "中山疫情防控服务平台",
      imgUrl: "https://zsrbactivity.zsnews.cn" + require("../assets/zsplus.png"),
      description: "疫情防控一点通",
      url: "https://zsrbactivity.zsnews.cn/vue/epidemic/",
      successMethod: ""
    })
  }
}
</script>

<style lang="scss" scoped>
.container {
  background-color: #8acdf7;
  min-height: 100vh;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.swiper-carousel {
  // padding-bottom: 10px;
  .lazy_img {
    width: 100%;
    height: auto;
  }
}
.header {
  // position: absolute;
  width: 100%;
  height: auto;
  left: 0;
  top: 0;
}
.form {
  position: relative;
  // margin-top: 200px;
  margin-left: 14px;
  margin-right: 14px;
  z-index: 3;
}

.form-content {
  // padding: 6px;
  background-color: white;
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 10px;
}
.form-top {
  background-color: white;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-bottom: 5px;
  padding-bottom: 10px;
  box-shadow: 0 2px 5px -2px rgba($color: #000000, $alpha: 0.4);
  .title {
    margin-top: 10px;
    color: #f87670;
    font-weight: 600;
    font-size: 4.5vw;
  }
  .divider {
    width: 90%;
    // --van-divider-margin:7px 0;
  }
  .positive-container {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .positive-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    //  .positive-right{
    //   display: flex;
    //   justify-content: flex-start;
    //   align-items: center;
    // }
    .positive-text {
      font-size: 3.4vw;
    }
    .positive-num {
      font-size: 4.2vw;
      padding: 0 5px;
      color: #f87670;
      font-weight: 700;
    }
  }
}
.form-image {
  width: 14vw;
  height: 14vw;
}
.form-text {
  font-size: 3.2vw;
  color: #444;
}
.grid-item {
  --van-grid-item-content-padding: 16px 0;
}
.wx-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.copyright {
  width: 100%;
  color: white;
  font-size: 14px;
  text-align: center;
  margin-bottom: 30px;
}
</style>
